export const SCHOOL_CALENDAR_FETCHING = 'SCHOOL_CALENDAR_FETCHING';
export const SCHOOL_CALENDAR_FETCH = 'SCHOOL_CALENDAR_FETCH';
export const SCHOOL_CALENDAR_FETCH_ERROR = 'SCHOOL_CALENDAR_FETCH_ERROR';
export const SCHOOL_CALENDAR_SUBMITTING = 'SCHOOL_CALENDAR_SUBMITTING';
export const SCHOOL_CALENDAR_SUBMIT = 'SCHOOL_CALENDAR_SUBMIT';
export const SCHOOL_CALENDAR_SUBMIT_ERROR = 'SCHOOL_CALENDAR_SUBMIT_ERROR';
export const SCHOOL_CALENDAR_CLEAR_ERROR_SUCCESS =
  'SCHOOL_CALENDAR_CLEAR_ERROR_SUCCESS';
export const SCHOOL_CALENDAR_ADD_EXCEPTION = 'SCHOOL_CALENDAR_ADD_EXCEPTION';
export const SCHOOL_CALENDAR_REMOVE_EXCEPTION =
  'SCHOOL_CALENDAR_REMOVE_EXCEPTION';
export const SCHOOL_CALENDAR_EDIT_EXCEPTION = 'SCHOOL_CALENDAR_EDIT_EXCEPTION';
export const SCHOOL_CALENDAR_DELETING = 'SCHOOL_CALENDAR_DELETING';
export const SCHOOL_CALENDAR_DELETE = 'SCHOOL_CALENDAR_DELETE';
export const SCHOOL_CALENDAR_DELETE_ERROR = 'SCHOOL_CALENDAR_DELETE_ERROR';
export const SCHOOL_CALENDAR_TOGGLE_ASSIGNMENT =
  'SCHOOL_CALENDAR_TOGGLE_ASSIGNMENT';
export const SCHOOL_CALENDAR_TOGGLE_ALL_ASSIGNMENTS =
  'SCHOOL_CALENDAR_TOGGLE_ALL_ASSIGNMENTS';



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/state/calendar/types.js